import { render, staticRenderFns } from "./case.vue?vue&type=template&id=793d38a0&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=793d38a0&prod&lang=scss&scoped=true&"
import style1 from "./case.vue?vue&type=style&index=1&id=793d38a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d38a0",
  null
  
)

export default component.exports